/* src/app/xapi/xapi.component.scss */
/*# sourceMappingURL=xapi.component.css.map */
